import { Shield } from 'lucide-react';
import { phiText } from '../lib/phiConfig';

export function HipaaFooter() {
  return (
    <footer
      data-testid="global-footer"
      className="mt-auto border-t border-[var(--color-border)] bg-[var(--color-surface-2)] px-4 py-4 text-center text-xs text-[var(--color-muted)]"
    >
      <div className="flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-3 max-w-7xl mx-auto">
        <div
          data-testid="hipaa-secured-badge-footer"
          className="inline-flex items-center gap-1.5 px-2 py-1 rounded-full bg-[rgba(13,140,140,0.10)] text-[#0B6F6F] border border-[rgba(13,140,140,0.20)] font-medium"
        >
          <Shield size={12} className="shrink-0" />
          {phiText('HIPAA Secured', 'Secured')}
        </div>
        <span className="hidden sm:inline">•</span>
        <span>Operon Management · {phiText('HIPAA Compliant', 'Compliant')} · Data Encrypted · BAA on File</span>
      </div>
    </footer>
  );
}
